import React from 'react';

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ title, onClose }) => {
  return (
    <div className="flex items-center justify-between border-b border-gray-100 dark:border-gray-800 px-6 py-4">
      <h3 className="text-lg font-bold text-gray-950 dark:text-white">{title}</h3>
      <button
        onClick={onClose}
        className="rounded-lg p-1 hover:bg-gray-105 dark:hover:bg-gray-800 text-gray-400 hover:text-gray-650"
      >
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};
export default ModalHeader;
